export default {"src":"/_next/static/media/doctor.3382c2ab.svg","height":65,"width":58,"blurWidth":0,"blurHeight":0};